/* eslint semi: ["error", "never"]*/

/* eslint arrow-parens: ["error", "as-needed"]*/

/* eslint key-spacing: ["error", { "afterColon": true, "align": "value" }] */

/* eslint no-multi-spaces: ["error", { exceptions: { "ImportDeclaration": true,
                                       "VariableDeclarator": true  } }] */
import 'cross-fetch/polyfill';
import { USER_STATUS } from '@engine/actions/action-types';
import { setFlashMessage } from '@engine/actions/creators/flash-message';
/**
 * Action Creators for User Status
 */

export var requestUserStatus = function requestUserStatus(userID) {
  return {
    type: USER_STATUS(userID).request
  };
};
export var receiveUserStatus = function receiveUserStatus(userID, data) {
  return {
    type: USER_STATUS(userID).receive,
    data: data
  };
};
export var failUserStatus = function failUserStatus(userID) {
  return {
    type: USER_STATUS(userID).fail
  };
};
export var updateUserStatus = function updateUserStatus(userID, data) {
  return {
    type: USER_STATUS(userID).update,
    data: data
  };
};
export function fetchUserStatus(url, userID) {
  return function (dispatch) {
    dispatch(requestUserStatus(userID));
    return fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        authenticity_token: window.CSRF
      })
    }).then(function (response) {
      return response.json();
    }).then(function (json) {
      return dispatch(receiveUserStatus(userID, json));
    })["catch"](function () {
      dispatch(setFlashMessage({
        status: 'warning',
        content: I18n.t('javascript.errors.something_went_wrong')
      }));
      dispatch(failUserStatus(userID));
    });
  };
}